/* global globalThis */
const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
export const RANDOM_PREFIX_PATTERN = /^[A-Za-z]{2}$/;
export const USER_SUFFIX_PATTERN = /^[A-Za-z0-9가-힣._-]{1,120}$/;
const accountPattern = /^(0[C-F]|[1-9A-F][0-9A-F])$/;

export function generateRandomPrefix(exclude) {
  let result;
  do {
    result = '';
    while (result.length < 2) {
      const bytes = globalThis.crypto.getRandomValues(new Uint8Array(4));
      for (const byte of bytes) {
        // 52의 배수 범위만 사용해 나머지 연산의 편향을 없앤다.
        if (byte < 208 && result.length < 2) result += alphabet[byte % 52];
      }
    }
  } while (result === exclude);
  return result;
}

export function formatPublicSlug(randomPrefix, accountCode, userSuffix) {
  const code = typeof accountCode === 'string' ? accountCode.toUpperCase() : '';
  if (typeof randomPrefix !== 'string' || typeof userSuffix !== 'string'
    || !RANDOM_PREFIX_PATTERN.test(randomPrefix) || !accountPattern.test(code)
    || !USER_SUFFIX_PATTERN.test(userSuffix || '')) throw new Error('공개 슬러그 구성을 확인해주세요.');
  return `${randomPrefix}${code}${userSuffix}`;
}

export function parsePublicIdentifier(value) {
  if (typeof value !== 'string') throw new Error('공개 주소를 확인해주세요.');
  const randomPrefix = value.slice(0, 2), accountCode = value.slice(2, 4).toUpperCase(), userSuffix = value.slice(4);
  const slug = formatPublicSlug(randomPrefix, accountCode, userSuffix);
  return { randomPrefix, accountCode, userSuffix, slug };
}

// 보존 필드의 실제 문자열만 복원한다. 관리 코드나 제목으로 값을 추정하지 않는다.
export function getPromotionSlugParts(promotion) {
  if (promotion.slugVersion === 2) {
    try {
      const parsed = parsePublicIdentifier(promotion.slug);
      if (parsed.slug === promotion.slug && parsed.randomPrefix === promotion.randomPrefix && parsed.userSuffix === promotion.userSuffix)
        return { randomPrefix: parsed.randomPrefix, userSuffix: parsed.userSuffix, source: 'current' };
    } catch { /* 손상된 현재 주소는 보존 필드로 덮어 추정하지 않는다. */ }
    return null;
  }
  for (const source of ['legacySlug', 'publishedKey']) {
    const value = promotion[source];
    if (typeof value === 'string' && RANDOM_PREFIX_PATTERN.test(value.slice(0, 2)) && USER_SUFFIX_PATTERN.test(value.slice(2)))
      return { randomPrefix: value.slice(0, 2), userSuffix: value.slice(2), source };
  }
  return null;
}
